import api from '../../../../api/client'

function normalizeOptionsPayload(data) {
  if (Array.isArray(data)) return data
  if (Array.isArray(data?.items)) return data.items
  return []
}

export async function listUsers(params) {
  const { data } = await api.get('/users/', { params })
  return data
}

export async function getUserDetail(userId) {
  const { data } = await api.get(`/users/${userId}`)
  return data
}

export async function createUser(payload) {
  const { data } = await api.post('/users/', payload)
  return data
}

export async function updateUser(userId, payload) {
  const { data } = await api.put(`/users/${userId}`, payload)
  return data
}

export async function archiveUser(userId) {
  const { data } = await api.post(`/users/${userId}/archive`)
  return data
}

export async function unlockUser(userId) {
  const { data } = await api.post(`/users/${userId}/unlock`)
  return data
}

export async function resetUserPassword(userId, newPassword) {
  const { data } = await api.post(`/users/${userId}/reset-password`, { new_password: newPassword })
  return data
}

export async function uploadUserProfilePhoto(userId, file) {
  const formData = new FormData()
  formData.append('file', file)

  const { data } = await api.post(`/users/${userId}/profile-photo`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

  return data
}

export async function listRoleOptions(params) {
  const { data } = await api.get('/options/roles', { params })
  return normalizeOptionsPayload(data)
}

export async function listCompanyOptions(params) {
  const { data } = await api.get('/options/companies', { params })
  return normalizeOptionsPayload(data)
}

export async function listBranchOptions(params) {
  const { data } = await api.get('/options/branches', { params })
  return normalizeOptionsPayload(data)
}

export async function listDepartmentOptions(params) {
  const { data } = await api.get('/options/departments', { params })
  return normalizeOptionsPayload(data)
}

export async function listUserOptions(params) {
  const { data } = await api.get('/options/users', { params })
  return normalizeOptionsPayload(data)
}

export async function listAdditionalCostOptions(params) {
  const { data } = await api.get('/options/additional-costs', { params })
  return normalizeOptionsPayload(data)
}

export async function listShiftOptions(params) {
  const { data } = await api.get('/options/shifts', { params })
  return normalizeOptionsPayload(data)
}
